// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 134,
  argument: "An exhortation to praise God: the vanity of idols.",
  verses: [
    { n: 1, text: "Alleluia. Praise ye the name of the Lord: O you, his servants, praise the Lord:" },
    { n: 2, text: "You that stand in the house of the Lord, in the courts of the house of our God." },
    { n: 3, text: "Praise ye the Lord, for the Lord is good: sing ye to his name, for it is sweet." },
    { n: 4, text: "For the Lord hath chosen Jacob unto himself: Israel for his own possession." },
    { n: 5, text: "For I have known that the Lord is great, and our God above all gods." },
    { n: 6, text: "Whatsoever the Lord pleased he hath done, in heaven, in earth, in the sea, and in all the deeps." },
    { n: 7, text: "He bringeth up lightnings from the ends of the earth: he hath made lightnings for the rain. He bringeth forth winds out of his stores:" },
    { n: 8, text: "He slew the first-born of Egypt, from man even unto beasts." },
    { n: 9, text: "He sent forth signs and wonders in the midst of thee, O Egypt: upon Pharao, and upon all his servants." },
    { n: 10, text: "He smote many nations, and slew mighty kings:" },
    { n: 11, text: "Sehon, king of the Amorrhites, and Og, king of Basan, and all the kingdoms of Chanaan." },
    { n: 12, text: "And gave their land for an inheritance, for an inheritance to his people Israel." },
    { n: 13, text: "Thy name, O Lord, is for ever: thy memorial, O Lord, unto all generations." },
    { n: 14, text: "For the Lord will judge his people, and will be entreated in favour of his servants." },
    { n: 15, text: "The idols of the Gentiles are silver and gold, the works of men's hands." },
    { n: 16, text: "They have a mouth, but they speak not: they have eyes, but they see not." },
    { n: 17, text: "They have ears, but they hear not: neither is there any breath in their mouths." },
    { n: 18, text: "Let them that make them be like to them: and every one that trusteth in them." },
    { n: 19, text: "Bless the Lord, O house of Israel: bless the Lord, O house of Aaron." },
    { n: 20, text: "Bless the Lord, O house of Levi: you that fear the Lord, bless the Lord." },
    { n: 21, text: "Blessed be the Lord out of Sion, who dwelleth in Jerusalem." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Alleluia. The psalm turns on God's praises, and might be composed by David, after he had settled the order of the Levites, though it may suit all people. (Berthier) — The latter part agrees with Psalm cxiii., and Jeremias x., which might lead us to conclude that it was composed after the captivity, perhaps for the dedication of the second temple. The next psalm is a repetition of this, with the chorus interspersed.", attribution: "Calmet" }
    ] },
    { verse: 2, notes: [
      { text: "Courts. Both clergy and laity praise God for his favours and power.", attribution: "Worthington" }
    ] },
    { verse: 3, notes: [
      { text: "Sweet. Occupation, and very useful, Psalm cxlvi. 1.", attribution: "Calmet" }
    ] },
    { verse: 4, notes: [
      { text: "Possession. Hebrew, \"jewel,\" \"property.\" Chaldean, \"well-beloved.\" See Deuteronomy lii. 8., and Ecclesiasticus xvii. 14. (Calmet) — The first patriarchs corresponded with God's goodness: but their descendants were for the most part ungrateful: so that Christians have now entered into their place, and must praise God.", attribution: "Berthier" }
    ] },
    { verse: 5, notes: [
      { text: "Gods. Whatever is so esteemed by men. (St. Chrysostom) — He then proceeds to shew the vanity of such false gods.", attribution: "Calmet" }
    ] },
    { verse: 7, notes: [
      { text: "Earth. The Mediterranean sea is so called, Luke xii. 54. — Rain. Indicating, or causing rain. (Haydock) — The most incompatible things are united. (Theodoret) — The sinner melts into tears at the sight of God's judgments. (St. Augustine) — Stores, which are his will and decrees. (Theodoret)", attribution: "Jeremias li. 16." }
    ] },
    { verse: 14, notes: [
      { text: "Entreated. Deuteronomy xxxii. 36. \"Have pity,\" (Berthier) or revenge.", attribution: "Haydock" }
    ] },
    { verse: 20, notes: [
      { text: "Fear. It was important to distinguish the priests from the people.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
